import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private apiRootSubject: ReplaySubject<string> = new ReplaySubject<string>(1);
  private throwOnQpdErrorsSubject: boolean;

  /**
   * Returns an observable which will emit the current API root. If configuration is modified, the new API root url will
   * be emitted from the same observable.
   */
  getApiRoot(): Observable<string> {
    return this.apiRootSubject.asObservable();
  }

  /**
   * Sets the API root for the application
   * @param apiRoot
   */
  setApiRoot(apiRoot: string): void {
    this.apiRootSubject.next(apiRoot);
  }

  /**
   * Gets whether errors from the QPD (QModel) should be thrown as exceptions or skipped.
   */
  getThrowOnQpdErrors(): boolean {
    return this.throwOnQpdErrorsSubject;
  }

  /**
   * Sets whether errors from the QPD (QModel) should be thrown as exceptions or skipped.
   * @param throwOnQpdErrors If true, errors will be thrown as exceptions, otherwise they will be skipped
   */
  setThrowOnQpdErrors(throwOnQpdErrors: boolean) {
    this.throwOnQpdErrorsSubject = throwOnQpdErrors;
  }
}
